const variants = {
  default: {
    backgroundColor: "rgba(190, 191, 190, 0.3)",
    color: "lighter-text-color",
  },
  active: {
    backgroundColor: "count-active-background-color",
    color: "cta-button-text-color-hover",
  },
};

export default variants;
